<template>
  <div id="app">
    <!--主体-->
    <Home />
    <!--顶部导航-->
    
    
    <!--<router-view /> -->
  </div>
</template>
<script>

import Home from '@/views/home/home.vue'



export default {
  components:{
    Home
  },

  data() {
    return {
    }
  },
  created() {
  },
  beforeUpdate() {
    //console.log(this.$route)
    if (this.$route.path == '/nav') {
      this.loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      // debugger
      this.nav = false
      this.loading.close()
    }
    if (this.$route.query.keyWord != false) {
      this.index = this.$route.query.keyWord
    }
  },
  methods: {
    
  },
}
</script>
<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

.index {
  width: 100%;
}


/***滚动条样式 */
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}
::-webkit-scrollbar-thumb {
    background-color: #c7c5c6;
    border-radius: 1px;
}
</style>
